module.exports = __webpack_public_path__ + "static/media/rules@2x.c9c758c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_209/images/rules@2x.png
// module id = 1734
// module chunks = 0